.root {
  gap: 0.75rem;
  border-radius: var(--border-radius__sm);
  display: inline-flex;

  /* https://react-spectrum.adobe.com/react-aria/VisuallyHidden.html#gotchas */
  /* https://github.com/adobe/react-spectrum/pull/8091 */
  position: relative;
}

.root:not([data-disabled]) {
  cursor: pointer;
}

.root[data-disabled] {
  cursor: not-allowed;
}

/* prettier-ignore */
.checkbox:not(:is([data-selected], [data-indeterminate], [data-invalid], [data-disabled])) {
  background-color: var(--color__white);
  color: var(--ds-checkbox-deselected-border-color);
}

/* prettier-ignore */
.checkbox[data-disabled]:not(:is([data-selected], [data-indeterminate])) {
  background-color: var(--ds-checkbox-disabled-background-color);
  color: var(--ds-checkbox-disabled-border-color);
}

/* prettier-ignore */
.checkbox[data-disabled]:is([data-selected], [data-indeterminate]) {
  background-color: currentColor;
  color: var(--ds-checkbox-disabled-selected-border-color);
}

/* prettier-ignore */
.checkbox:is([data-selected], [data-indeterminate]):not(:is([data-disabled], [data-invalid])) {
  background-color: currentColor;
  color: var(--ds-checkbox-selected-border-color);
}

/* prettier-ignore */
.checkbox[data-invalid]:not([data-disabled]) {
  color: var(--ds-checkbox-invalid-border-color);

}

/* prettier-ignore */
.checkbox[data-invalid]:is([data-selected], [data-indeterminate]):not([data-disabled]) {
  background-color: currentColor;
}

.checkbox {
  --ds-checkbox-deselected-border-color: var(--color__gray-400);
  /* Selected controls are lilac-500: white on it clears AA (4.5:1), where the
     white checkmark on the blue this replaced sat at 2.6:1. Blue is the active
     nav item's colour only — see DESIGN.md, Every colour has one job. */
  --ds-checkbox-selected-border-color: var(--color__lilac-500);
  --ds-checkbox-invalid-border-color: var(--color__red-400);
  --ds-checkbox-disabled-border-color: var(--color__gray-300);
  --ds-checkbox-disabled-selected-border-color: var(--color__gray-500);
  --ds-checkbox-disabled-background-color: var(--color__gray-50);

  inline-size: 1.25rem;
  block-size: 1.25rem;
  border-width: 2px;
  border-style: solid;
  border-color: currentColor;
  border-radius: var(--border-radius__sm);
  transition:
    border-color 200ms,
    background-color 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.checkmark {
  inline-size: 1rem;
  block-size: 1rem;
  fill: var(--color__white);
  transition: opacity 200ms;
}

.checkbox:not(:is([data-selected], [data-indeterminate])) .checkmark {
  opacity: 0;
}

.checkbox:is([data-selected], [data-indeterminate]) .checkmark {
  opacity: 1;
}

.alignment-center {
  align-items: center;
}

.alignment-top {
  align-items: baseline;
}
